import { createAction } from '../../../../../store.model';
import { ViewRow, WpDataRowParamsAtSegment } from '../../core';
import { ActionType } from '../main.action';

export interface ExpandRow {
    rowId: string;
    drillPathIdentifier: string;
    segmentIdentifier: string;
    paramsAtSegment: WpDataRowParamsAtSegment;
}

export const expandRow = createAction<ActionType, ExpandRow>(
    ActionType.WP_MAIN__EXPAND_ROW,
);

export interface ExpandRowResult extends ExpandRow {
    rows?: ViewRow[];
}

export const expandRowResult = createAction<ActionType, ExpandRowResult>(
    ActionType.WP_MAIN__EXPAND_ROW_RESULT,
);

export interface ExpandRowCancel {
    rowId: string;
}

export const expandRowCancel = createAction<ActionType, ExpandRowCancel>(
    ActionType.WP_MAIN__EXPAND_ROW_CANCEL,
);
